import { ChatMessage, ApiChatNewMessage } from "Types"

export const formatChatMessage = (message: ChatMessage, negotiationId: number, identifier: string): ApiChatNewMessage => ({
  identifier: identifier,
  companyQuotationId: negotiationId,
  tag: message.type,
  description: message.message || 'Anexo',
  amount: message.budget,
  files: message.files.map(item => item.path),
})

export default {
  formatChatMessage,
}